/* eslint-disable no-underscore-dangle */
import { fabric, LayerManager } from '@aibee/vincent';
// eslint-disable-next-line import/no-unresolved
import svg from '@/assets/icons/svg/location.svg';

// 全景点
fabric.PanoramaPoint = fabric.util.createClass(fabric.Group, {

  type: 'PanoramaPoint',

  initialize(options) {
    this.initParams(options);
    const { shapeParams = {} } = this.config;
    shapeParams.hoverCursor = 'pointer';
    shapeParams.selectable = false;
    fabric.loadSVGFromString(svg.content.replace(/symbol/g, 'svg'), (objects, opt) => {
      const obj = fabric.util.groupSVGElements(objects, opt);
      obj.scale(0.05);
      this.callSuper('initialize', [obj], shapeParams);
      LayerManager.getCurrentLayer().canvas.renderAll();
    });

    this.initEvents();
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      property: this.property,
    });
  },

  _render(ctx) {
    this.callSuper('_render', ctx);
  },
});
